module.exports = __webpack_public_path__ + "img/latitude-interest-free-logo-reverse.0c769a2a.svg";